import { ProjectCard } from "@components/common/project-card/project-card";
import { DEFAULT_PROJECTS_SORT_BY } from "@components/projects/projects-sort-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { BaseProjectProps } from "@custom-types/project-types";
import { Box } from "@mui/material";
import { cardWidth } from "@utils/ui-utils";

/** Popup content rendered when a map marker is clicked. */
export function ProjectMarkerPopupContent({
  project,
}: BaseProjectProps): JSX.Element {
  const companyId = useCompanyId();

  return (
    /** Without this Box container, the ProjectCard would be smaller in some areas due to container limitations. */
    <Box sx={{ width: cardWidth.sm }}>
      <ProjectCard
        companyId={companyId}
        project={project}
        numberOfProjects={1}
        sortBy={DEFAULT_PROJECTS_SORT_BY}
        isThumbnailLink={true}
      />
    </Box>
  );
}
